import {
    FETCH_DASHBOARD_LIST,
    FETCH__DELETED_DASHBOARD_LIST,
    FETCH_SYSTEM_WIDGETS_LIST,
    FETCH_WIDGETS_LIST_DASHBOARD,
    FETCH_PUBLIC_DASHBOARD_INFO,
    UPDATE_CURRENT_DASHBOARD,
    UPDATE_CURRENT_DASHBOARD_FIELD,
    FETCH_CHART_DATA,
    FETCH_CHART_DATA_2,
    RESET_CURRENT_DASHBOARD_FILTER,
    APPLY_FILTER_DASHBOARD,
    UPDATE_FILTER_REFINE_SORT_DASHBOARD,
    UPDATE_TAB_IN_VIEW,
    UPDATE_DASHBOARD_IN_VIEW,
    UPDATE_CONVERSATION_LAYOUT,
    FETCH_CONVERSATION_DATA,
    REMOVE_CURRENT_DASHBOARD,
    UPDATE_CUSTOM_QUERY_DASHBOARD,
    ADD_CUSTOM_QUERY,
    EDIT_CURRENT_DASHBOARD,
    ADD_WIDGET_TO_DASHBOARD,
    DELETE_WIDGET_FROM_DASHBOARD,
    DELETE_DASHBOARD,
    UPDATE_LIST_DASHBOARD_FIELD,
    UPDATE_DASHBOARD_LAYOUT_CONFIG,
    SENTIMENT_UPDATE,
    DASHBOARD_BULK_SENTIMENT_UPDATE,
    DASHBOARD_BULK_CONTENT_SAFETY_UPDATE,
    DASHBOARD_BULK_MARK_IRR_UPDATE,
    REMOVE_IRR_POST,
    UPDATE_POSTS_AFTER_SENTIMENT_UPDATE,
    UPDATE_POSTS_AFTER_TAG_CLIENT,
    UPDATE_POSTS_AFTER_MARK_IRR,
    UPDATE_POSTS_AFTER_SENTIMENT_UPDATE_WIDGET,
    UPDATE_POSTS_AFTER_TAG_CLIENT_WIDGET,
    UPDATE_POSTS_AFTER_MARK_IRR_WIDGET,
    UPDATE_POSTS_AFTER_DELETE_FROM_COLLECTION,
    DASHBOARD_SHOW_BULK_EDIT_OPTIONS,
    DASHBOARD_TOGGLE_SELECT_ALL,
    DASHBOARD_TOGGLE_SELECTED,
    DASHBOARD_TOGGLE_TO_DESELECT,
    DASHBOARD_BULK_DELETE_FROM_COLLECTION,
    UPDATE_TEMPORARY_PAGE_FILTERS,
    UPDATE_RESEARCH_PAGE_FILTERS,
    DASHBOARD_UPDATING_STATUS,
    SAVE_DASHBOARD_WIDGET_LAYOUT_CONFIG,
    TOGGLE_FILTERS_COLUMN,
    SET_STATIC_CHART_LOADER,
    UPDATE_GRID_LAYOUT,
    FETCH_FILTER_VALUE__FOR_IMAGE,
    FETCH_IMAGE_LOGO_LIST,
    FETCH_IMAGE_SCENES_LIST,
    FETCH_IMAGE_OBJECTS_LIST,
    APPLY_IMAGE_FILTER,
    SET_CUSTOM_VALUE,
    UPDATE_DASHBOARD_CHART,
    SHARE_WITH_PUBLIC,
    STOP_SHARE_WITH_PUBLIC,
    IMAGE_ANALYTICS_MODAL_OPEN,
    SHOW_CHARTS_DRILLDOWN,
    UPDATE_CHART_INSIGHTS_FILTERS,
    UPDATE_DASHBOARD,
    VIEW_EXCLUDED_WORDS,
    MAXIMIZE_WIDGET,
    // DELETE_COMPETITOR_ACCOUNT,
    PUBLISHED_UPDATE_FILTER_REFINE_SORT_DASHBOARD,
    FETCH_ADVANCE_CHART_DATA_WRAPPER,
    EXCLUDE_VIEW_COUNT_CHECKBOX,
} from "../actions/dashboardAction";

import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import moment from "moment-timezone";
import { charts } from "../components/MainContent/Dashboard/Charts/utils";
import { multiMetricFormation } from "./advanceMetricFormation";

const initialState = {
    customDashboards: [],
    dashboardsSharedByMe: [],
    standardDashboards: [],
    dashboardsSharedToMe: [],
    favouriteDashboards: [],
    recentlyViewedDashboards: [],
    dashboardsSharedToPublic: [],
    deletedDashboards: [],
    chartStaticLoading: false,
    dashboardListLoading: false,
    dashboardListError: false,

    systemWidgetsList: [],
    systemWidgetsListObject: {},
    systemWidgetsGroupObject: {},
    systemWidgetsListLoading: false,
    systemWidgetsListError: false,

    widgetListDashboard: [],
    widgetListDashboardCurrent: {},
    widgetListDashboardLoading: false,
    widgetListDashboardError: false,
    widgetUpdated: 0,
    widgetFilterUpdated: null,

    widgetListDashboardData: {},
    widgetListDashboardDataLoading: {},
    widgetListDashboardDataError: {},

    widgetListDashboardStateData: {},
    widgetListDashboardStateDataLoading: {},
    widgetListDashboardStateDataError: {},

    currentDashboard: null,
    currentListDashboard: null,
    ImageObjects: [],
    ImageScenes: [],
    ImageSystemLogos: [],
    ImageOwnLogos: [],

    // filters
    filters: {},
    drilldown_filters: {},
    imageAnalyticsFilters: {
        ocr_custom_query: [],
        logos: [],
        scenes: [],
        objects: [],
    },
    filterRefineSort: "published_date_desc",
    publishedFilterRefineUpdate: 0,
    publishedFilterRefineSort: "published_date_desc",
    filterRefineFilter: {
        sentiment: ["all"],
        sentimentType: "all",
        media: "all",
        postType: "all",
        postSubType: "all",
        sampling: "100",
        channel: "all",
        exclusion: "yes",
        contentSafety: "sfw",
        contentSafetyType: "all",
    },
    customQuery: "",
    filterUpdated: 0,
    filterRefineUpdate: 0,
    otherFiltersUpdated: 0,

    showBulkOptions: false,
    selectAll: false,
    totalPostsSelected: false,
    selectedPosts: [],
    deselectedPosts: [],

    viewTypeInTab: "4-col",
    tabInView: "analytics",
    // tabInView: "conversations",
    dashboardInView: "sharedWithMe",

    conversationsData: null,
    conversationsDataLoading: false,
    conversationsDataError: null,
    conversationOffset: 1,
    totalConversationsData: 0,
    noOfPostsFetched: 0,
    listView: false,
    conversationsDataParams: null,

    postComments: [],
    postCommentsFetching: false,
    postCommentsRejected: false,

    editCurrentDashboard: false,

    dashboardLayoutConfig: [],
    dashboardUpdated: 0,
    filtersExpanded: false,
    // searchValueforCustom: "",

    trainLogoData: [],
    systemLogoData: [],
    publicSharingToken: "",
    imageAnalyticsModalOpen: false,
    chartComarisonDateRange: [],
    show_charts_drilldown: false,
    drilled_down_chartName: "",
    viewExcludedWords: false,
    maximizeWidgetValue: null,
    wordcloudWordUnexcluded: false,
    toggleDeleteCompetitorAccount: false,
    showAdvanceEditor: false,
    advanceWidgetDashboardData: {},
    advanceWidgetDashboardDataLoading: false,
    advanceDashboardDataLoadingWidgetWise: {},
    viewCountCheckboxes: {},
    manualReloadCount: 0,
};

const capitaliseWord = (val) => {
    let splitStr = val.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
};

const formatImageData = (data) => {
    let formatedData = {
        systemLogo: {
            brand_identifier: [],
            brand_name: [],
        },
        ownLogo: [],
        labelName: [],
        formatTrainLogoData: [],
        formatSystemLogoData: [],
    };

    Object.keys(data).forEach((key) => {
        if (key === "systemLogos") {
            data[key].map((v) => {
                let logoData = {
                    images: [],
                    logoName: "",
                    id: "",
                };

                logoData.images.push(
                    v.variants.length > 0 &&
                        v.variants.map((val) => {
                            return val.url;
                        }),
                );

                logoData.id = v.id;
                logoData.show_in_filter = v.show_in_filter;
                logoData.logoName = v.brand_name;
                logoData.is_selected = v.is_selected;
                formatedData.formatSystemLogoData.push(logoData);

                if (v.show_in_filter === 1) {
                    formatedData.systemLogo.brand_identifier.push(v.brand_identifier);
                    formatedData.systemLogo.brand_name.push(v.brand_name);
                }
            });
        }

        if (key === "ownLogos") {
            data[key].map((v) => {
                let logoData = {
                    images: [],
                    logoName: "",
                    status: "",
                    id: "",
                };

                // let value = capitaliseWord(v.brand_identifier);

                logoData.images.push(
                    v.variants.map((val) => {
                        return val.url;
                    }),
                );
                logoData.id = v.id;
                logoData.status = v.train_status;
                logoData.logoName = v.brand_name;
                logoData.created_at = v.created_at;
                logoData.user_id = v.user_id;
                formatedData.formatTrainLogoData.push(logoData);

                formatedData.ownLogo.push(v.brand_identifier);
            });
        }

        if (key === "scenes" || key === "objects") {
            data[key].map((v) => {
                // let value = capitaliseWord(v.label_name.replace(/_/g, " "));
                formatedData.labelName.push(v.label_name);
            });
        }
    });

    formatedData.systemLogo.brand_identifier.sort((a, b) => {
        if (a.toLowerCase() > b.toLowerCase()) return 1;
        else return -1;
    });
    formatedData.systemLogo.brand_name.sort((a, b) => {
        if (a.toLowerCase() > b.toLowerCase()) return 1;
        else return -1;
    });

    return formatedData;
};

const refineFilterReducer = (query) => {
    let updatedRefineFilter = { ...initialState.filterRefineFilter };
    let updatedQuery = query && Object.keys(query);
    let keyNames = Object.keys(initialState.filterRefineFilter);

    if (query) {
        for (let j = 0; j < Object.keys(query).length; j++) {
            for (let i = 0; i < Object.keys(initialState.filterRefineFilter).length; i++) {
                if (updatedQuery[j] === keyNames[i] && initialState.filterRefineFilter[keyNames[i]] != query[updatedQuery[j]]) {
                    updatedRefineFilter[keyNames[i]] = query[updatedQuery[j]];
                }
            }
        }
    }

    return updatedRefineFilter;
};

const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case isPending(FETCH_DASHBOARD_LIST):
            return {
                ...state,
                dashboardListLoading: true,
                dashboardListError: null,
            };
        case isRejected(FETCH_DASHBOARD_LIST):
            return {
                ...state,
                dashboardListLoading: true,
                dashboardListError: true,
            };
        case isFulfilled(FETCH_DASHBOARD_LIST):
            return {
                ...state,
                standardDashboards:
                    action.payload.standardDashboards.sort((a, b) => a.dashboard_config.layout.default_order - b.dashboard_config.layout.default_order) || [],
                customDashboards: action.payload.customDashboards || [],
                dashboardsSharedToMe: [...action.payload.dashboardsSharedToCompany, ...action.payload.dashboardsSharedToTeam] || [],
                dashboardsSharedByMe: action.payload.dashboardsSharedByMe || [],
                favouriteDashboards: action.payload.favouriteDashboards || [],
                recentlyViewedDashboards: action.payload.recentlyViewedDashboards || [],
                dashboardsSharedToPublic: action.payload.dashboardsSharedToPublic || [],
                dashboardListLoading: false,
                dashboardListError: false,
            };
        case isFulfilled(FETCH__DELETED_DASHBOARD_LIST):
            return {
                ...state,
                deletedDashboards: action.payload.dashboards || [],
            };

        case isFulfilled(FETCH_IMAGE_LOGO_LIST):
            return {
                ...state,
                ImageSystemLogos: formatImageData(action.payload).systemLogo.brand_name,
                // .systemLogo.sort((a, b) => {
                //     if (a.toLowerCase() > b.toLowerCase()) return 1;
                //     else return -1;
                // }),
                ImageOwnLogos: formatImageData(action.payload).ownLogo.sort((a, b) => {
                    if (a.toLowerCase() > b.toLowerCase()) return 1;
                    else return -1;
                }),

                trainLogoData: formatImageData(action.payload).formatTrainLogoData.sort(function (a, b) {
                    return moment(b.created_at).format("X") - moment(a.created_at).format("X");
                }),
                systemLogoData: formatImageData(action.payload).formatSystemLogoData,
            };

        case "EDIT_LOGO_ITEM":
            return {
                ...state,
                editItem: action.payload.editItem,
            };

        case isFulfilled(FETCH_IMAGE_SCENES_LIST):
            return {
                ...state,
                ImageScenes: formatImageData(action.payload).labelName.sort((a, b) => {
                    if (a.toLowerCase() > b.toLowerCase()) return 1;
                    else return -1;
                }),
            };
        case isFulfilled(FETCH_IMAGE_OBJECTS_LIST):
            return {
                ...state,
                ImageObjects: formatImageData(action.payload).labelName.sort((a, b) => {
                    if (a.toLowerCase() > b.toLowerCase()) return 1;
                    else return -1;
                }),
            };
        case isPending(FETCH_SYSTEM_WIDGETS_LIST):
            return {
                ...state,
                systemWidgetsListLoading: true,
                systemWidgetsListError: null,
            };
        case isRejected(FETCH_SYSTEM_WIDGETS_LIST):
            return {
                ...state,
                systemWidgetsListLoading: true,
                systemWidgetsListError: true,
            };
        case isFulfilled(FETCH_SYSTEM_WIDGETS_LIST): {
            let systemWidgetsListObject = {};
            let widgetsNotFound = [];
            const systemWidgetsGroupObject = {};
            action.payload.widgets.forEach((w) => {
                let c = charts.find((widget) => w.chart_name === widget.name);
                if (c && c.chartgroup) {
                    c.chartgroup.forEach((cg) => {
                        if (!systemWidgetsGroupObject[cg]) {
                            systemWidgetsGroupObject[cg] = [w];
                        } else systemWidgetsGroupObject[cg].push(w);
                    });
                } else widgetsNotFound.push(w.chart_name);
                systemWidgetsListObject[w.id] = w.widget_filter?.layout || {};
            });
            // let systemWidgetsList = [];
            // action.payload.widgets.forEach((w) => (widgetsNotFound.includes(w.chart_name) ? "" : systemWidgetsList.push(w)));
            return {
                ...state,
                // systemWidgetsList,
                systemWidgetsListObject,
                systemWidgetsGroupObject,
                systemWidgetsListLoading: false,
                systemWidgetsListError: false,
            };
        }
        case REMOVE_CURRENT_DASHBOARD:
            return {
                ...state,
                widgetListDashboardData: {},
                widgetListDashboardDataLoading: {},
                widgetListDashboardDataError: {},
                widgetListDashboardStateData: {},
                widgetListDashboardStateDataLoading: {},
                widgetListDashboardStateDataError: {},
                currentDashboard: null,
                currentCollection: null,
                filters: initialState.filters,
                filterUpdated: initialState.filterUpdated,
                filterRefineSort: initialState.filterRefineSort,
                filterRefineFilter: initialState.filterRefineFilter,
                filterRefineUpdate: initialState.filterRefineUpdate,
                otherFiltersUpdated: initialState.otherFiltersUpdated,
                tabInView: initialState.tabInView,
                viewTypeInTab: initialState.viewTypeInTab,
                //gridView:initialState.gridView,
                customQuery: initialState.customQuery,
                editCurrentDashboard: false,
                totalPostsSelected: false,
                showBulkOptions: false,
                selectAll: false,
                selectedPosts: [],
                deselectedPosts: [],
                dashboardUpdated: 0,
                filtersExpanded: false,
                dashboardLayoutConfig: [],
                imageAnalyticsFilters: initialState.imageAnalyticsFilters,
                // searchValueforCustom: "",
            };
        case UPDATE_CURRENT_DASHBOARD:
        case isFulfilled(UPDATE_CURRENT_DASHBOARD):
            if (action.payload?.response?.data?.status === "error" || action.payload?.deleted === "1") return { ...state };
            // console.log("firstaction", action.payload);
            return {
                ...state,
                widgetListDashboardData: {},
                widgetListDashboardDataLoading: {},
                widgetListDashboardStateData: {},
                widgetListDashboardStateDataLoading: {},
                currentDashboard: action.payload,
                filters: action.payload && JSON.parse(JSON.stringify(action.payload?.dashboard_config.query)),
                customQuery: action.payload?.dashboard_config.query.filterKeyword,
                filterUpdated: 0,
                filterRefineFilter: action.payload && refineFilterReducer(action.payload?.dashboard_config.refineFilter),
                imageAnalyticsFilters: action.payload?.dashboard_config.imageAnalyticsFilters
                    ? action.payload?.dashboard_config.imageAnalyticsFilters
                    : state.imageAnalyticsFilters,
            };
        case UPDATE_TEMPORARY_PAGE_FILTERS: {
            let { filter, filterImageOptions, custom_query, refineOptions, widgetInfo, filterSortType } = action.payload;
            // console.log("oooooo");
            return {
                ...state,
                filters: JSON.parse(JSON.stringify(filter)),
                customQuery: custom_query,
                filterRefineFilter: refineOptions,
                filterRefineSort: filterSortType,
                imageAnalyticsFilters: filterImageOptions,
                // searchValueforCustom: searchValueforCustom,

                // filterRefineFilter: JSON.parse(JSON.stringify(refineOptions)),
                filterUpdated: 0,
                filterRefineUpdate: 0,
                otherFiltersUpdated: 0,
            };
        }
        case UPDATE_RESEARCH_PAGE_FILTERS: {
            // console.log("oooooo");
            let widgetListDashboard = action.payload;
            let widgetListDashboardCurrent = {};
            action.payload.forEach((w) => {
                widgetListDashboardCurrent[w.id] = w;
            });
            return {
                ...state,
                filters: {
                    topics: [],
                    subtopics: [],
                    countries: ["selectAll"],
                    duration: "30",
                    platforms: ["selectAll"],
                    languages: ["selectAll"],
                    publications: [],
                    entitySubType: "all",
                    entityType: "all",
                },
                widgetListDashboard,
                widgetListDashboardCurrent,
                widgetListDashboardLoading: false,
                widgetListDashboardError: false,
            };
        }
        case isFulfilled(UPDATE_DASHBOARD): {
            if (action.payload.skipReduxStateUpdate || action.payload?.response?.data?.status === "error") return state;
            const update = action.payload;
            const comparator = (d) => (d.id === update.id ? { ...d, ...update.data } : d);
            let standardDashboards = state.standardDashboards.map(comparator);
            let customDashboards = state.customDashboards.map(comparator);
            let dashboardsSharedToMe = state.dashboardsSharedToMe.map(comparator);
            let dashboardsSharedByMe = state.dashboardsSharedByMe.map(comparator);
            let favouriteDashboards = state.favouriteDashboards.map(comparator);
            let recentlyViewedDashboards = state.recentlyViewedDashboards.map(comparator);
            let dashboardsSharedToPublic = state.dashboardsSharedToPublic.map(comparator);

            return {
                ...state,
                standardDashboards,
                customDashboards,
                dashboardsSharedToMe,
                dashboardsSharedByMe,
                favouriteDashboards,
                recentlyViewedDashboards,
                dashboardsSharedToPublic,
            };
        }

        case UPDATE_CURRENT_DASHBOARD_FIELD: {
            // console.log("firstaction", action.payload);
            return {
                ...state,
                currentDashboard: { ...state.currentDashboard, [action.payload.field]: action.payload.value },
            };
        }

        case UPDATE_LIST_DASHBOARD_FIELD: {
            return {
                ...state,
                currentListDashboard: { ...state.currentListDashboard, [action.payload.field]: action.payload.value },
            };
        }

        case RESET_CURRENT_DASHBOARD_FILTER: {
            // console.log("firstaction", action.payload);
            let filters = {
                filterRefineFilter: initialState.filterRefineFilter,
                filterUpdated: 0,
                filterRefineSort: initialState.filterRefineSort,
                filterRefineUpdate: 0,
            };
            if (state.currentDashboard) filters.filters = JSON.parse(JSON.stringify(state.currentDashboard.dashboard_config.query));
            return {
                ...state,
                ...filters,
            };
        }
        case APPLY_FILTER_DASHBOARD: {
            // console.log("oooooo", action.payload);
            return {
                ...state,
                filters: action.payload.filters,
                filterRefineFilter: action.payload.filterRefineFilter,
                imageAnalyticsFilters: action.payload.imageAnalyticsFilters,
                filterUpdated: state.filterUpdated + 1,
                customQuery: action.payload.customQuery,
            };
        }

        case APPLY_IMAGE_FILTER: {
            return {
                ...state,
                imageAnalyticsFilters: action.payload.imageAnalyticsFilters,
                customQuery: action.payload.customQuery,
                otherFiltersUpdated: state.otherFiltersUpdated + 1,
            };
        }

        case IMAGE_ANALYTICS_MODAL_OPEN: {
            return {
                ...state,
                imageAnalyticsModalOpen: action.payload,
            };
        }

        // case SET_CUSTOM_VALUE: {
        //     return {
        //         ...state,
        //         searchValueforCustom: action.payload,
        //     };
        // }
        case isPending(FETCH_WIDGETS_LIST_DASHBOARD):
            return {
                ...state,
                widgetListDashboardLoading: true,
                widgetListDashboardError: null,
            };
        case isRejected(FETCH_WIDGETS_LIST_DASHBOARD):
            return {
                ...state,
                widgetListDashboardLoading: false,
                widgetListDashboardError: true,
            };
        case isFulfilled(FETCH_WIDGETS_LIST_DASHBOARD): {
            let widgetListDashboard = action.payload.widgets;
            let widgetListDashboardCurrent = {};
            action.payload.widgets.forEach((w) => {
                widgetListDashboardCurrent[w.id] = w;
            });
            return {
                ...state,
                widgetListDashboard,
                widgetListDashboardCurrent,
                widgetListDashboardLoading: false,
                widgetListDashboardError: false,
            };
        }
        case isFulfilled(FETCH_CHART_DATA): {
            // console.log("firstchartdattta", action);positiveData
            let widgetListDashboardData = state.widgetListDashboardData;
            let widgetListDashboardDataLoading = state.widgetListDashboardDataLoading;
            let widgetListDashboardDataError = state.widgetListDashboardDataError;

            if (action.comparisionData) widgetListDashboardData[action.widgetId + "_comparison"] = action.payload;
            else widgetListDashboardData[action.widgetId] = action.payload;

            if (action.comparisionData) widgetListDashboardDataLoading[action.widgetId + "_comparison"] = false;
            else widgetListDashboardDataLoading[action.widgetId] = false;
            // widgetListDashboardDataLoading[action.widgetId] = false;

            if (action.comparisionData) widgetListDashboardDataError[action.widgetId + "_comparison"] = false;
            else widgetListDashboardDataError[action.widgetId] = false;
            // widgetListDashboardDataError[action.widgetId] = false;
            return {
                ...state,
                widgetListDashboardData,
                widgetListDashboardDataLoading,
                widgetListDashboardDataError,
            };
        }
        case isPending(FETCH_CHART_DATA): {
            let widgetListDashboardData = state.widgetListDashboardData;
            let widgetListDashboardDataLoading = state.widgetListDashboardDataLoading;
            let widgetListDashboardDataError = state.widgetListDashboardDataError;
            if (action.comparisionData) widgetListDashboardData[action.widgetId + "_comparison"] = null;
            else widgetListDashboardData[action.widgetId] = null;

            if (action.comparisionData) {
                widgetListDashboardDataLoading[action.widgetId + "_comparison"] = true;
            } else widgetListDashboardDataLoading[action.widgetId] = true;

            if (action.comparisionData) widgetListDashboardDataError[action.widgetId + "_comparison"] = false;
            else widgetListDashboardDataError[action.widgetId] = false;
            // widgetListDashboardDataLoading[action.widgetId] = true;
            // widgetListDashboardDataError[action.widgetId] = false;
            return {
                ...state,
                widgetListDashboardData,
                widgetListDashboardDataLoading,
                widgetListDashboardDataError,
            };
        }
        case isRejected(FETCH_CHART_DATA): {
            let widgetListDashboardData = state.widgetListDashboardData;
            let widgetListDashboardDataLoading = state.widgetListDashboardDataLoading;
            let widgetListDashboardDataError = state.widgetListDashboardDataError;

            widgetListDashboardData[action.widgetId] = null;
            widgetListDashboardDataLoading[action.widgetId] = false;
            widgetListDashboardDataError[action.widgetId] = true;
            return {
                ...state,
                widgetListDashboardData,
                widgetListDashboardDataLoading,
                widgetListDashboardDataError,
            };
        }

        case isPending(FETCH_ADVANCE_CHART_DATA_WRAPPER): {
            // console.log("firstchartdatttaaction", action.payload);
            let widgetListDashboardData = state.widgetListDashboardData;
            // widgetListDashboardData = {};
            let advanceDashboardDataLoadingWidgetWise = JSON.parse(JSON.stringify(state.advanceDashboardDataLoadingWidgetWise));
            if (action.payload?.widget?.id) {
                advanceDashboardDataLoadingWidgetWise[action.payload?.widget?.id] = true;
            }
            return {
                ...state,
                advanceWidgetDashboardDataLoading: true,
                advanceDashboardDataLoadingWidgetWise,
                widgetListDashboardData,
            };
        }
        case isFulfilled(FETCH_ADVANCE_CHART_DATA_WRAPPER): {
            // console.log("firstchartdatttaaction", action, state.widgetListDashboardData);
            let widgetListDashboardData = state.widgetListDashboardData;
            let advanceWidgetDashboardData = {};
            let advanceDashboardDataLoadingWidgetWise = JSON.parse(JSON.stringify(state.advanceDashboardDataLoadingWidgetWise));
            if (action.payload && action.payload[0]?.widgetId) {
                if (action.payload.length > 1) {
                    widgetListDashboardData[action.payload[0]?.widgetId] = multiMetricFormation(action.payload);
                    advanceDashboardDataLoadingWidgetWise[action.payload[0]?.widgetId] = false;
                } else {
                    // console.log("firstchartdatttaactionpppp", action.payload[0]?.payload,action);
                    widgetListDashboardData[action.payload[0]?.widgetId] = action.payload[0]?.payload;
                    advanceDashboardDataLoadingWidgetWise[action.payload[0]?.widgetId] = false;
                }
            } else if (action.payload.length > 1) {
                advanceWidgetDashboardData = multiMetricFormation(action.payload);
            } else {
                // advanceWidgetDashboardData = action.payload && action.payload[0]?.payload[0];
                advanceWidgetDashboardData = action.payload && action.payload[0]?.payload;
            }
            return {
                ...state,
                advanceWidgetDashboardData: advanceWidgetDashboardData,
                // advanceWidgetDashboardDataLoading: state.showAdvanceEditor ? false : state.advanceWidgetDashboardDataLoading,
                advanceWidgetDashboardDataLoading: false,
                advanceDashboardDataLoadingWidgetWise,
                widgetListDashboardData,
            };
        }
        case isRejected(FETCH_ADVANCE_CHART_DATA_WRAPPER): {
            let advanceDashboardDataLoadingWidgetWise = JSON.parse(JSON.stringify(state.advanceDashboardDataLoadingWidgetWise));
            let widgetId = action.payload?.arg?.widget?.id || null;
            if (widgetId) {
                advanceDashboardDataLoadingWidgetWise[widgetId] = false;
            }
            return {
                ...state,
                advanceWidgetDashboardDataLoading: false,
                advanceDashboardDataLoadingWidgetWise,
            };
        }
        case isFulfilled(FETCH_CHART_DATA_2): {
            let widgetListDashboardStateData = state.widgetListDashboardStateData;
            let widgetListDashboardStateDataLoading = state.widgetListDashboardStateDataLoading;
            let widgetListDashboardStateDataError = state.widgetListDashboardStateDataError;
            widgetListDashboardStateData[action.widgetId] = action.payload;
            widgetListDashboardStateDataLoading[action.widgetId] = false;
            widgetListDashboardStateDataError[action.widgetId] = false;
            return {
                ...state,
                widgetListDashboardStateData,
                widgetListDashboardStateDataLoading,
                widgetListDashboardStateDataError,
            };
        }
        case isPending(FETCH_CHART_DATA_2): {
            let widgetListDashboardStateData = state.widgetListDashboardStateData;
            let widgetListDashboardStateDataLoading = state.widgetListDashboardStateDataLoading;
            let widgetListDashboardStateDataError = state.widgetListDashboardStateDataError;
            widgetListDashboardStateData[action.widgetId] = null;
            widgetListDashboardStateDataLoading[action.widgetId] = true;
            widgetListDashboardStateDataError[action.widgetId] = false;
            return {
                ...state,
                widgetListDashboardStateData,
                widgetListDashboardStateDataLoading,
                widgetListDashboardStateDataError,
            };
        }
        case isRejected(FETCH_CHART_DATA_2): {
            let widgetListDashboardStateData = state.widgetListDashboardStateData;
            let widgetListDashboardStateDataLoading = state.widgetListDashboardStateDataLoading;
            let widgetListDashboardStateDataError = state.widgetListDashboardStateDataError;
            widgetListDashboardStateData[action.widgetId] = null;
            widgetListDashboardStateDataLoading[action.widgetId] = false;
            widgetListDashboardStateDataError[action.widgetId] = true;
            return {
                ...state,
                widgetListDashboardStateData,
                widgetListDashboardDataLoading,
                widgetListDashboardStateDataError,
            };
        }
        case isPending(FETCH_CONVERSATION_DATA): {
            return {
                ...state,
                conversationsData: null,
                conversationsDataLoading: true,
                conversationsDataError: null,
                totalConversationsData: 0,
                noOfPostsFetched: 0,
            };
        }
        case isFulfilled(FETCH_CONVERSATION_DATA): {
            return {
                ...state,
                conversationsData: action.payload?.hits?.hits,
                conversationsDataLoading: false,
                conversationsDataError: null,
                conversationOffset: action.payload.offset,
                totalConversationsData: action.payload?.hits?.total,
                noOfPostsFetched: action.payload.hits?.hits?.length,
                conversationsDataParams: action.payload?.parmas,
            };
        }
        case isRejected(FETCH_CONVERSATION_DATA): {
            return {
                ...state,
                conversationsData: null,
                conversationsDataLoading: false,
                conversationsDataError: action.payload,
            };
        }
        case UPDATE_FILTER_REFINE_SORT_DASHBOARD:
            return { ...state, filterRefineSort: action.payload, filterRefineUpdate: state.filterRefineUpdate + 1 };

        case PUBLISHED_UPDATE_FILTER_REFINE_SORT_DASHBOARD:
            return { ...state, publishedFilterRefineSort: action.payload, publishedFilterRefineUpdate: state.filterRefineUpdate + 1 };
        case UPDATE_CUSTOM_QUERY_DASHBOARD: {
            const { value, applyFilter } = action.payload;
            if (applyFilter) return { ...state, customQuery: value, otherFiltersUpdated: state.otherFiltersUpdated + 1 };
            else return { ...state, customQuery: value };
        }
        case ADD_CUSTOM_QUERY:
            return { ...state, customQuery: action.payload };
        case UPDATE_TAB_IN_VIEW:
            return {
                ...state,
                tabInView: action.payload,
                widgetListDashboardData: {},
                widgetListDashboardDataLoading: {},
                dashboardUpdated: 0,
                listView: false,
            };
        case UPDATE_DASHBOARD_IN_VIEW:
            return {
                ...state,
                dashboardInView: action.payload,
            };
        case UPDATE_CONVERSATION_LAYOUT:
            return { ...state, listView: action.payload };

        case UPDATE_GRID_LAYOUT:
            return { ...state, viewTypeInTab: action.payload };

        case UPDATE_DASHBOARD_LAYOUT_CONFIG:
            return { ...state, widgetListDashboardCurrent: action.payload };
        case DASHBOARD_UPDATING_STATUS:
            return { ...state, dashboardUpdated: action.payload ? state.dashboardUpdated + 1 : 0 };
        case isFulfilled(SAVE_DASHBOARD_WIDGET_LAYOUT_CONFIG): {
            let { widgetListDashboard, widgetListDashboardCurrent } = state;
            action.payload.forEach((w) => {
                widgetListDashboardCurrent[w.id] = w;
                let wId = widgetListDashboard.find((widget) => widget.id === w.id);
                widgetListDashboard[wId] = w;
            });
            return { ...state, dashboardUpdated: 0, widgetListDashboard, widgetListDashboardCurrent };
        }
        case EDIT_CURRENT_DASHBOARD:
            return { ...state, editCurrentDashboard: action.payload };
        case isFulfilled(ADD_WIDGET_TO_DASHBOARD): {
            // console.log("firstadddd", action.payload);
            let widgetListDashboardCurrent = state.widgetListDashboardCurrent;
            widgetListDashboardCurrent[action.payload.customWidget.id] = action.payload.customWidget;
            return {
                ...state,
                widgetListDashboard: state.widgetListDashboard.concat(action.payload.customWidget),
                widgetListDashboardCurrent,
                // filterUpdated: state.filterUpdated + 1,
            };
        }
        case isFulfilled(DELETE_WIDGET_FROM_DASHBOARD): {
            let widgetListDashboard = state.widgetListDashboard.filter((w) => w.id !== action.payload);
            let widgetListDashboardCurrent = state.widgetListDashboardCurrent;
            delete widgetListDashboardCurrent[action.payload];
            let widgetListDashboardData = state.widgetListDashboardData;
            let widgetListDashboardDataLoading = state.widgetListDashboardDataLoading;
            let widgetListDashboardDataError = state.widgetListDashboardDataError;
            delete widgetListDashboardData[action.payload];
            delete widgetListDashboardDataLoading[action.payload];
            delete widgetListDashboardDataError[action.payload];
            return {
                ...state,
                widgetListDashboard,
                widgetListDashboardCurrent,
                widgetListDashboardData,
                widgetListDashboardDataLoading,
                widgetListDashboardDataError,
            };
        }

        case isFulfilled(SENTIMENT_UPDATE): {
            const conversationsData = [...state.conversationsData];
            conversationsData[action.payload.postIndex] = action.payload.data;
            return {
                ...state,
                conversationsData,
            };
        }
        case UPDATE_POSTS_AFTER_SENTIMENT_UPDATE: {
            return {
                ...state,
                conversationsData: action.payload,
            };
        }
        case UPDATE_POSTS_AFTER_TAG_CLIENT: {
            return {
                ...state,
                conversationsData: action.payload,
            };
        }
        case UPDATE_POSTS_AFTER_MARK_IRR: {
            return {
                ...state,
                conversationsData: action.payload,
                totalConversationsData: state.totalConversationsData - 1,
            };
        }
        case TOGGLE_FILTERS_COLUMN: {
            return {
                ...state,
                filtersExpanded: action.payload,
            };
        }
        case UPDATE_POSTS_AFTER_DELETE_FROM_COLLECTION: {
            return {
                ...state,
                conversationsData: action.payload,
                totalConversationsData: state.totalConversationsData - 1,
            };
        }
        case UPDATE_POSTS_AFTER_SENTIMENT_UPDATE_WIDGET: {
            let widgetListDashboardData = state.widgetListDashboardData;
            widgetListDashboardData[action.payload.widgetId] = action.payload.conversationsData;
            return {
                ...state,
                widgetListDashboardData,
            };
        }
        case UPDATE_POSTS_AFTER_TAG_CLIENT_WIDGET: {
            let widgetListDashboardData = state.widgetListDashboardData;
            widgetListDashboardData[action.payload.widgetId] = action.payload.conversationsData;
            return {
                ...state,
                widgetListDashboardData,
            };
        }
        case UPDATE_POSTS_AFTER_MARK_IRR_WIDGET: {
            let widgetListDashboardData = state.widgetListDashboardData;
            widgetListDashboardData[action.payload.widgetId] = action.payload.conversationsData;
            return {
                ...state,
                widgetListDashboardData,
            };
        }
        case isFulfilled(REMOVE_IRR_POST):
            return {
                ...state,
                conversationsData: state.conversationsData.filter((post) => post._id !== action.payload.postId),
                totalConversationsData: state.totalConversationsData - 1,
            };
        case DASHBOARD_SHOW_BULK_EDIT_OPTIONS:
            if (action.payload)
                return {
                    ...state,
                    showBulkOptions: action.payload,
                };
            else
                return {
                    ...state,
                    showBulkOptions: action.payload,
                    totalPostsSelected: false,
                    selectAll: false,
                    selectedPosts: [],
                    deselectedPosts: [],
                };
        case DASHBOARD_TOGGLE_SELECT_ALL:
            return {
                ...state,
                totalPostsSelected: !state.totalPostsSelected,
                selectAll: action.payload !== undefined ? action.payload : !state.totalPostsSelected,
                selectedPosts: [],
                deselectedPosts: [],
            };

        case DASHBOARD_TOGGLE_SELECTED: {
            let newSelectedPosts = null;
            if (state.selectedPosts.indexOf(action.payload) > -1) newSelectedPosts = state.selectedPosts.filter((id) => id !== action.payload);
            else newSelectedPosts = state.selectedPosts.concat([action.payload]);
            return {
                ...state,
                selectedPosts: newSelectedPosts,
                totalPostsSelected: false,
                selectAll: false,
            };
        }
        case DASHBOARD_TOGGLE_TO_DESELECT: {
            let newDeselectedPosts = null;
            if (state.deselectedPosts.indexOf(action.payload) > -1) newDeselectedPosts = state.deselectedPosts.filter((id) => id !== action.payload);
            else newDeselectedPosts = state.deselectedPosts.concat([action.payload]);
            return {
                ...state,
                deselectedPosts: newDeselectedPosts,
                totalPostsSelected: false,
            };
        }
        case isFulfilled(DASHBOARD_BULK_SENTIMENT_UPDATE): {
            return {
                ...state,
                conversationsData: action.payload,
                conversationsDataLoading: false,
            };
        }

        case isFulfilled(DASHBOARD_BULK_CONTENT_SAFETY_UPDATE): {
            return {
                ...state,
                conversationsData: action.payload,
                conversationsDataLoading: false,
            };
        }

        case isFulfilled(DASHBOARD_BULK_MARK_IRR_UPDATE): {
            return {
                ...state,
                conversationsData: state.conversationsData.filter((post) => action.payload.ids.indexOf(post._id) === -1),
                totalConversationsData: state.totalConversationsData - action.payload.ids.length,
            };
        }
        case isFulfilled(DASHBOARD_BULK_DELETE_FROM_COLLECTION): {
            const ids = action.payload.map((i) => i.split(":")[1]);
            return {
                ...state,
                conversationsData: state.conversationsData.filter((post) => ids.indexOf(post._id) === -1),
                totalConversationsData: state.totalConversationsData - ids.length,
            };
        }
        case isRejected("FETCH_POST_COMMENTS"):
            return {
                ...state,
                postCommentsFetching: false,
                postCommentsRejected: true,
            };
        case isFulfilled("FETCH_POST_COMMENTS"):
            return {
                ...state,
                // postComments: action.payload,
                postCommentsFetching: false,
            };
        case isPending("FETCH_POST_COMMENTS"):
            return {
                ...state,
                postComments: [],
                postCommentsFetching: true,
                postCommentsRejected: false,
            };

        case SET_STATIC_CHART_LOADER:
            return {
                ...state,
                chartStaticLoading: action.payload,
            };

        case isFulfilled(UPDATE_DASHBOARD_CHART): {
            let widgetListDashboard = state.widgetListDashboard;
            let widgetListDashboardCurrent = state.widgetListDashboardCurrent;
            let ind = widgetListDashboard.findIndex((w) => w.id === action.payload.id);
            if (ind !== undefined) {
                widgetListDashboard[ind] = action.payload.data;
                widgetListDashboardCurrent[action.payload.id] = action.payload.data;
            }

            return {
                ...state,
                widgetListDashboard,
                //chartComarisonDateRange:action.payload.data.widget_filter.ChartComparisionDate,
                widgetListDashboardCurrent,
                widgetUpdated: state.widgetUpdated + 1,
                //  filters:action.payload.data.widget_filter.query.filters,
            };
        }

        // case isFulfilled(SHARE_WITH_PUBLIC): {
        //     return {
        //         ...state,
        //         publicSharingToken: action.payload.dashboard.access_token,
        //     };
        // }

        // case isFulfilled(STOP_SHARE_WITH_PUBLIC): {
        //     return {
        //         ...state,
        //     };
        // }

        case "CHANGE_CHART_FILTERS": {
            let widgetListDashboardCurrent = state.widgetListDashboardCurrent;
            widgetListDashboardCurrent[action.payload.id] = action.payload.widget;
            return {
                ...state,
                widgetListDashboardCurrent,
                widgetFilterUpdated: action.payload.id,
            };
        }

        case "SHOW_CHARTS_DRILLDOWN": {
            return {
                ...state,
                show_charts_drilldown: action.payload[0],
                drilled_down_chartName: action.payload[1],
            };
        }

        case "UPDATE_CHART_INSIGHTS_FILTERS": {
            return {
                ...state,
                drilldown_filters: JSON.parse(JSON.stringify(action.payload)),
            };
        }
        case VIEW_EXCLUDED_WORDS: {
            return { ...state, viewExcludedWords: action.payload.payload, wordcloudWordUnexcluded: action.payload.payload ? false : action.payload.deleted };
        }

        case MAXIMIZE_WIDGET: {
            return { ...state, maximizeWidgetValue: action.payload };
        }
        // case DELETE_COMPETITOR_ACCOUNT: {
        //     return { ...state, toggleDeleteCompetitorAccount: !state.toggleDeleteCompetitorAccount };
        // }

        case "ADVANCE_EDITOR":
            return {
                ...state,
                showAdvanceEditor: action.payload,
                advanceWidgetDashboardDataLoading: action.payload ? false : state.advanceWidgetDashboardDataLoading,
                // filterUpdated: !action.payload ? state.filterUpdated + 1 : state.filterUpdated,
            };

        case "RELOAD_TOP_TOPICS_BY_DATA_USAGE": {
            let advanceWidgetDashboardDataLoading = state.advanceWidgetDashboardDataLoading;
            let manualReloadCount = state.manualReloadCount;
            if (action.payload.loading) advanceWidgetDashboardDataLoading = true;
            if (action.payload.reload) manualReloadCount += 1;

            return { ...state, advanceWidgetDashboardDataLoading, manualReloadCount };
        }

        case "RESET_RELOAD_COUNT":
            return { ...state, manualReloadCount: 0 };

        case EXCLUDE_VIEW_COUNT_CHECKBOX:
            // console.log("lllll", action.payload);
            return {
                ...state,

                // filterUpdated: state.filterUpdated + 1,
                viewCountCheckboxes: {
                    ...state.viewCountCheckboxes,
                    [action.payload.widgetId]: action.payload.isChecked,
                },
            };

        default:
            return state;
    }
};

export default dashboardReducer;
